import { V3Models } from "@istari/istari-client";

import { ResourceType } from "~/resource/model/resource-type";

export function toResourceType(resourceType: V3Models.ResourceTypeDto | string): ResourceType {
  switch (resourceType) {
    case V3Models.ResourceTypeDto.Model:
      return ResourceType.Model;
    case V3Models.ResourceTypeDto.Artifact:
      return ResourceType.Artifact;
    case V3Models.ResourceTypeDto.File:
      return ResourceType.File;
    case V3Models.ResourceTypeDto.ConnectedContainer:
      return ResourceType.ConnectedContainer;
    case V3Models.ResourceTypeDto.ConnectedResource:
      return ResourceType.ConnectedResource;
    default:
      return ResourceType.File;
  }
}
